export default __webpack_public_path__ + "media/images/email-b60f1c89.png";